import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyStellantisMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="stellantisGradient" cx="50%" cy="50%" r="60%">
          <stop offset="0%" style={{ stopColor: "#FFFFFF", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#E0E0E0", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#2C2C2C", stopOpacity: 1 }} />
        </radialGradient>
      </defs>
      <rect width={width} height={height} fill="url(#stellantisGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {Array.from({ length: 20 }).map((_, star) => {
          const angle = (star / 20) * 2 * Math.PI;
          const radius = 150 + (star % 5) * 60;
          const x = Math.cos(angle) * radius;
          const y = Math.sin(angle) * radius;
          const starPoints: string[] = [];
          for (let p = 0; p < 5; p++) {
            const pAngle = (p / 5) * 2 * Math.PI - Math.PI / 2;
            const r = p % 2 === 0 ? 20 : 10;
            starPoints.push(`${x + Math.cos(pAngle) * r},${y + Math.sin(pAngle) * r}`);
          }
          return (
            <polygon
              key={`star-${star}`}
              points={starPoints.join(" ")}
              fill="none"
              stroke="#2C2C2C"
              strokeWidth={1.5}
              opacity={0.3}
            />
          );
        })}
        {Array.from({ length: 16 }).map((_, r) => (
          <circle
            key={`constellation-${r}`}
            cx={0}
            cy={0}
            r={(r + 1) * 25}
            fill="none"
            stroke="#2C2C2C"
            strokeWidth={r % 4 === 0 ? 2.5 : 1.5}
            opacity={0.3 - r * 0.014}
          />
        ))}
        <circle cx={0} cy={0} r={55} fill="none" stroke="#2C2C2C" strokeWidth={3} opacity={0.6} />
        <circle cx={0} cy={0} r={38} fill="#E0E0E0" opacity={0.5} />
      </g>
    </svg>
  );
};
